

export class SelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput implements ISelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id!: number;
    /** The vehicle number with vehicle name */
    vehicle_number!: string;

    constructor(data?: ISelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.vehicle_number = _data["vehicle_number"];
        }
    }

    static fromJS(data: any): SelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["vehicle_number"] = this.vehicle_number;
        return data; 
    }
}

export interface ISelectByCompanyIdBranchIdAndVehicleTypeIdOutputOutput {
    /** The auto-generated id of the tbl vehicle details master */
    vehicle_details_id: number;
    /** The vehicle number with vehicle name */
    vehicle_number: string;
}

